export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["昨天"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["聊天"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["今天"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星期一"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星期二"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星期三"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星期四"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星期五"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星期六"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星期日"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1月"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2月"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["3月"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["4月"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["5月"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["6月"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["7月"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["8月"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9月"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["10月"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["11月"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["12月"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["你"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理员"])}
}